module.exports = __webpack_public_path__ + "img/41.df21b375.jpg";